import * as React from "react";
import type { SVGProps } from "react";
const SvgSuitcaseBadgePlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.5 1C20.53 1 23 3.47 23 6.5l-.01.01c0 1.17-.37 2.26-1 3.15v9.39c0 1.06-.84 1.92-1.89 1.96 0 .55-.45 1-1 1s-1-.45-1-1H5.89c0 .55-.45 1-1 1s-1-.45-1-1.01C2.84 20.96 2 20.1 2 19.04V8.96C2 7.88 2.88 7 3.96 7H8V5c0-.55.45-1 1-1h3.61c.91-1.78 2.76-3 4.89-3ZM21 6.5C21 4.57 19.43 3 17.5 3S14 4.57 14 6.5s1.57 3.5 3.5 3.5S21 8.43 21 6.5Zm-5 5.29A5.527 5.527 0 0 1 12.61 9H8v10.03l8-.02v-7.22ZM12.03 6H10v1h2.03a4.07 4.07 0 0 1-.03-.5c0-.116.01-.233.018-.346L12.03 6ZM6 19.03V9H3.96L4 19.04h.71l.02-.007c.051-.017.098-.033.16-.033a.37.37 0 0 1 .097.016.324.324 0 0 0 .083.014H6Zm12-7.06V19l.01-.01H20.04l-.03-7.61c-.61.32-1.29.52-2.01.59ZM16.5 7.5H16c-.55 0-1-.45-1-1s.45-1 1-1h.5V5c0-.55.45-1 1-1s1 .45 1 1v.5h.5c.55 0 1 .45 1 1s-.45 1-1 1h-.5V8c0 .55-.45 1-1 1s-1-.45-1-1v-.5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSuitcaseBadgePlus;
